import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControl, FormControlLabel, Grid } from '@material-ui/core';
import useChecklistStyles from './useChecklistStyles';
import { stripLeadingNumber, isStudent, isAlumni, isFHT, isAdminOrFHT } from '../../../util/miscUtil';

function renderChecklistItem(item, form, setForm, classes, isFieldDisabled, isConfirmDisabled, emailAddress, number) {
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      style={{ marginBottom: 10 }}
      className={classes.unprintedContent + ' ' + classes.checkListRow}
      key={item.key}
    >
      <Grid item xs={12} sm={12} md={8} lg={8} className={classes.checklistColumn}>
        <FormControl fullWidth>
          <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <FormControlLabel
                control={<Checkbox color="default" style={{ alignSelf: 'flex-start' }} />}
                label={`${number}. ${stripLeadingNumber(item.label)}`}
                disabled={isFieldDisabled(form[item.confirmKey])}
                checked={form[item.key]}
                onChange={(event) => setForm({ ...form, [item.key]: !form[item.key] })}
              />
              {item.extra && item.key === 'liveAfterGraduation' && (
                <span style={{ marginLeft: 4, minWidth: 300, flex: 1, display: 'flex' }}>
                  {item.extra(form, emailAddress, isFieldDisabled, classes, setForm)}
                </span>
              )}
            </div>
            {item.extra && item.key !== 'liveAfterGraduation' && <div>{item.extra(form, emailAddress, isFieldDisabled, classes, setForm)}</div>}
          </>
        </FormControl>
      </Grid>
      <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '3%' }} className={classes.checklistColumn}>
        <div className={classes.pointsLabel}>{item.points}</div>
      </Grid>
      <Grid item xs={6} sm={6} md={2} lg={2} align="left" className={classes.checklistColumn}>
        <div className={classes.dueLabel}>{item.due}</div>
      </Grid>
      <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '2.5%' }} className={classes.checklistColumn}>
        <Checkbox
          color="default"
          disabled={isConfirmDisabled(form[item.key])}
          checked={form[item.confirmKey]}
          onChange={(event) => setForm({ ...form, [item.confirmKey]: !form[item.confirmKey] })}
        ></Checkbox>
      </Grid>
    </Grid>
  );
}

export default function GeneralItems(props) {
  const { form, setForm, auth, emailAddress, alumni, startIndex, formClasses, points, items } = props;

  const classes = useChecklistStyles();

  const hasItems = items && items.length > 0;

  const isFieldDisabled = (val) => {
    return !!isAdminOrFHT(auth.roles);
  };

  const isConfirmDisabled = (val) => {
    return !!(isStudent(auth.roles) || isAlumni(auth.roles) || isFHT(auth.roles));
  };
  return (
    <>
      {hasItems && (
        <Grid container direction="row" className={formClasses.sectionSpacer}>
          <Grid item xs={7} align="left">
            <section align="left" className={formClasses.sectionTitle}>
              General
            </section>
          </Grid>
          <Grid item xs={2}>
            <section align="right" className={formClasses.sectionTitle}>
              <div style={{ fontSize: '1.15rem', fontWeight: 600, paddingRight: 25 }} align="right">
                {points}
              </div>
            </section>
          </Grid>
          <Grid item xs={3}>
            <section align="center" className={formClasses.sectionTitle}>
              <br />
            </section>
          </Grid>
        </Grid>
      )}
      {hasItems &&
        items.map((item, index) =>
          renderChecklistItem(item, form, setForm, classes, isFieldDisabled, isConfirmDisabled, emailAddress, startIndex + index)
        )}
    </>
  );
}

GeneralItems.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  auth: PropTypes.object,
  emailAddress: PropTypes.string,
  alumni: PropTypes.bool.isRequired,
  startIndex: PropTypes.number,
  points: PropTypes.number,
  formClasses: PropTypes.object,
  items: PropTypes.array,
};
